import { render, staticRenderFns } from "./BotPressChat.vue?vue&type=template&id=20b0146c&scoped=true"
import script from "./BotPressChat.vue?vue&type=script&lang=js"
export * from "./BotPressChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0146c",
  null
  
)

export default component.exports